import { createSlice } from "@reduxjs/toolkit";
import { currentWeekPeriod } from "@/utils/date-range";
import { FilterStateDepositStores } from "./types";

const INITIAL_STATE: FilterStateDepositStores = {
  filters: {
    ...currentWeekPeriod(),
    pageSize: 20,
    meta: { page: 1 },
  },
};

const filterDepositStoresSlice = createSlice({
  name: "filterDepositStores",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = {
        ...currentWeekPeriod(),
        pageSize: 20,
        meta: { page: 1 },
      };
    },
  },
});

export const { setFilter, resetFilters } = filterDepositStoresSlice.actions;
export default filterDepositStoresSlice.reducer;
